import React, { useState } from 'react'
import { LINKS } from '@common/consts'
import { postGroupComment, postTrackComment, postNewsComment } from '@common/http'
import createProvider from '@store/provider'
import { connect, useSelector, useDispatch } from 'react-redux'
import { selectCurrentUser } from '@store/selectors/backendData'
import { setFlashMessageByValues } from '@store/actions/flashMessage'
import useAutoResizeTextArea from '@hooks/useAutoResizeTextArea'
import useEmailVerification from '@hooks/useEmailVerification'
import VerificationErrorBanner from '@components/verification-error-banner/VerificationErrorBanner'
import TextArea from '@components/text-area/text-area'
import Icon from '@components/icon'
import Linkton from '@components/linkton'
import * as styles from './CommunityWriteComment.module.scss'

const CommunityWriteComment = (props) => {
  const { mixdownId, newsId, groupId } = props

  const currentUser = useSelector(selectCurrentUser)
  const dispatch = useDispatch()

  const [comment, setComment] = useState('')
  const verification = useEmailVerification()

  const { setTextarea: assignTextareaEl } = useAutoResizeTextArea({ allowResize: false })

  const handleSubmit = async (e) => {
    e.preventDefault()
    e.stopPropagation()

    if (comment) {
      verification.clearErrors()
      try {
        if (groupId) await postGroupComment(groupId, comment)
        if (mixdownId) await postTrackComment(mixdownId, comment)
        if (newsId) await postNewsComment(newsId, comment)
        setComment('')
        window.dispatchEvent(new CustomEvent('comment:posted'))
      } catch (err) {
        if (verification.handleApiError(err)) return
        const status = err?.response?.status
        const errors = err?.response?.data?.errors
        if (status === 429) {
          dispatch(setFlashMessageByValues({ text: 'Hey there, slow down a little :)', type: 'notice' }))
        } else if (status === 422 && errors?.content) {
          dispatch(setFlashMessageByValues({ text: errors.content, type: 'error' }))
        } else {
          dispatch(setFlashMessageByValues({ text: 'Something went wrong. Please try again.', type: 'error' }))
        }
      }
    }

    return false
  }

  if (!currentUser) {
    return (
      <div className={styles.login}>
        <Icon icon='Log-in' size={24} />
        <small>Login to comment!</small>
        <Linkton className={styles.button} size='medium' tag='anchor' href={LINKS.AUTH_SIGN_IN}>Login</Linkton>
      </div>
    )
  }

  return (
    <div className={styles.container}>
      <form data-turbolinks={false} isDisabled={!comment} onSubmit={handleSubmit}>
        <div className={styles.avatarAndInput}>
          <img className={styles.img} src={currentUser.avatarSmallUrl} alt={`${currentUser.username} avatar`} />
          <TextArea ref={(r) => r && assignTextareaEl(r)} name='comment[content]' className={styles.textarea} maxLength='600' onChange={setComment} fontSize='small' isTransparent={false} value={comment} placeholder='Write a comment' />
        </div>

        <VerificationErrorBanner
          {...verification}
          verifyEmailMessage='Verify your email to comment'
          verifyEmailDescription='To help keep Soundation safe from spam, you need to verify your email address before commenting.'
        />
        <div className={styles.submit}>
          <Linkton className={styles.submitCta} isSubmit isDisabled={!comment}>Comment</Linkton>
        </div>
      </form>
    </div>
  )
}

export default createProvider(connect(null)(CommunityWriteComment, false))
